/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetCompanyResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'Company',
        isRequired: true,
      },
    },
  }],
} as const;
